import CancelledIcon from "../components/desktop/car-evaluation-step/images/inspection-cancelled.svg";
import { SCRAP_CARS_STEP_KEY } from "./scrap-cars-constants";

/* eslint-disable no-magic-numbers */
export const SELL_ONLINE_STEP_KEY = {
    BASIC_DETAILS: "basicdetails",
    CAR_CONDITION: "carcondition",
    FINAL_OFFER: "finaloffer",
    DOCUMENT_DETAILS: "documentdetails",
    APPOINTMENT_DETAILS: "appointmentdetails",
    DOCUMENT_UPLOAD: "documentupload",
    CONFIRMATION: "confirmation",
    PRICE_ESTIMATE: "priceEstimate",
    BOOK_INSPECTION: "bookInspection",
    INSPECTION_BOOKED: "inspectionBooked",
    RESCHEDULE: "RESCHEDULE"
};

export const NON_SELL_ONLINE_TAB_LIST = [
    {
        heading: "Car details",
        subHeading: "Tell us about your car details",
        key: SELL_ONLINE_STEP_KEY.BASIC_DETAILS,
        index: 1
    },
    // {
    //     heading: "Car condition",
    //     subHeading: "",
    //     key: SELL_ONLINE_STEP_KEY.CAR_CONDITION,
    //     index: 2
    // },
    {
        heading: "Estimated price",
        subHeading: "Estimated using market value, kms driven, and age",
        key: SELL_ONLINE_STEP_KEY.PRICE_ESTIMATE,
        index: 2
    },
    {
        heading: "Book  inspection",
        subHeading: "At home or the nearest Cars24 branch",
        key: SELL_ONLINE_STEP_KEY.BOOK_INSPECTION,
        index: 3
    },
    {
        heading: "Receive final price",
        subHeading: "At home or the nearest Cars24 branch",
        key: SELL_ONLINE_STEP_KEY.INSPECTION_BOOKED,
        index: 4
    }
];

export const SELL_ONLINE_TAB_LIST = [
    {
        heading: "Basic details",
        subHeading: "Brand, Model, Year, Variant, Fuel Type, Transmission Type, Kilometers Driven, State",
        key: SELL_ONLINE_STEP_KEY.BASIC_DETAILS,
        index: 1
    },
    {
        heading: "Car condition",
        subHeading: "",
        key: SELL_ONLINE_STEP_KEY.CAR_CONDITION,
        index: 2
    },
    {
        heading: "Final offer",
        subHeading: "",
        key: SELL_ONLINE_STEP_KEY.FINAL_OFFER,
        index: 3
    },
    {
        heading: "Schedule pick up",
        subHeading: "",
        key: SELL_ONLINE_STEP_KEY.APPOINTMENT_DETAILS,
        index: 4
    }
];

const sellOnlineStepKeyMap = {
    "Car details": SELL_ONLINE_STEP_KEY.BASIC_DETAILS,
    "Estimated price": SELL_ONLINE_STEP_KEY.PRICE_ESTIMATE,
    "Book inspection": SELL_ONLINE_STEP_KEY.BOOK_INSPECTION,
    "Receive final price": SELL_ONLINE_STEP_KEY.INSPECTION_BOOKED,
    "Inspection cancelled": SELL_ONLINE_STEP_KEY.INSPECTION_BOOKED
};

const sellOnlineFallbacks = [
    "Car details",
    "Estimated price",
    "Book inspection",
    "Receive final price",
    "Inspection cancelled"
];

const scrapStepKeyMap = {
    "Basic details": SCRAP_CARS_STEP_KEY.BASIC_DETAILS,
    "Price estimate": SCRAP_CARS_STEP_KEY.PRICE_ESTIMATE,
    "Self inspection": SCRAP_CARS_STEP_KEY.SELF_INSPECTION,
    "Receive final price": SCRAP_CARS_STEP_KEY.FINAL_PRICE
};

const scrapStepFallbacks = [
    "Basic details",
    "Price estimate",
    "Self inspection",
    "Receive final price"
];

const createStepFromData = ({ section, index, stepKeyMap, fallback }) => ({
    heading: section?.title?.value || fallback || `Step ${index}`,
    subHeading: section?.subTitle?.value || "",
    key: stepKeyMap[section?.title?.value] || stepKeyMap[fallback] || `step_${index}`,
    index,
    activeImage: section?.activeImage?.value?.url || "",
    inActiveImage: section?.inActiveImage?.value?.url || "",
    upcomingImage: section?.upcomingImage?.value?.url || section?.inActiveImage?.value?.url || ""
});

const getCancelledStep = (stepKey, index) => ({
    heading: "Inspection cancelled",
    subHeading: "We have cancelled the inspection for your car",
    key: stepKey,
    index,
    activeImage: CancelledIcon,
    inActiveImage: CancelledIcon,
    upcomingImage: CancelledIcon
});

export const stepperToRender = (isCancelled, sectionData, isScrap = false) => {
    if (!sectionData?.length) return [];

    const stepKeyMap = isScrap ? scrapStepKeyMap : sellOnlineStepKeyMap;
    const fallbacks = isScrap ? scrapStepFallbacks : sellOnlineFallbacks;

    const steps = sectionData.map((section, idx) =>
        createStepFromData({
            section,
            index: idx + 1,
            stepKeyMap,
            fallback: fallbacks?.[idx]
        })
    );

    if (isCancelled) {
        const cancelledStepKey = isScrap ? SCRAP_CARS_STEP_KEY.SELF_INSPECTION : SELL_ONLINE_STEP_KEY.INSPECTION_BOOKED;
        return steps.slice(0, 2).concat([getCancelledStep(cancelledStepKey, 3)]);
    }

    return steps;
};
